import React, { useState, useEffect } from "react";
import ManageAccountTab from "../ManageAccountTab";
import Account from "./Account";
import BusinessUserAccount from "./BusinessUserAccount/BusinessUserAccount";
import Preferences from "./Preferences";
import TwoFactorAuth from "./TwoFactorAuth";
import BillingInformation from "./BillingInformation/BillingInformation";
import FamilyProtection from "./FamilyProtection";
import IDFFamilyProtection from "./IDFFamilyProtection";
import DownloadApp from "../../Dashboard/DownloadApp";
import { DialogComponent } from "../../common/DialogComponent";
import FamilyProtectionDialog from "../../Dialogs/FamilyProtectionDialog";
import RedirectToMonitoring from "../../Dialogs/RedirectToMonitoring";
import ErrorBoundary from "../../common/ErrorBoundary";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as MyAccountActions from "../../../store/myAccount/actions";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import ManageAccountPassword from "./ManageAccountPassword";
import ManageAccountSecurity from "./ManageAccountSecurity";
import { useAreServicesActive } from "../../../util/CommonServices";
import { ezsServiceIds } from "../../../config/UserServicesList";
import { useCheckAnyServiceActive } from "../../../util/CommonServices";
import { Link } from "react-router-dom";
import LogoContainer from "../../common/LogoContainer";
import { useTranslation } from "react-i18next";
import TUAuthentication from "../../Credit/Auth/TUAuthentication";

const MyAccount = (props: any) => {
    const dispatch = useDispatch();
    const getAccountInformation = () => dispatch(MyAccountActions.actionCreators.getAccountInformation());
    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const isLoading = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState.isLoading : false));
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const [isFamilyProtectionDialogVisible, setFamilyProtectionDialogIsVisible] = useState(false);

    const isFamilyProtectionServiceActive = useAreServicesActive([ezsServiceIds.familyProtectionService]);
    const isSFRServiceActive = useAreServicesActive([
        ezsServiceIds.seniorsFraudRestoration,
        ezsServiceIds.seniorsFraudRestoration25K,
        ezsServiceIds.seniorsFraudRestoration1M,
    ]);
    const familyOffer = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState.familtOffer : null));
    const isLoadingFamilyOffer = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState.isLoadingFamilyOffer : false));
    const isBillingSectionHide = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isBillingSectionHide
            ? state.configurationState.configuration.partnerConfig.isBillingSectionHide
            : false
    );
   
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );
    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );

    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    ); 

    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [showDashboardSecurityQuestionDialog, setShowDashboardSecurityQuestionDialog] = useState(false);
    const [showRedirectPopup, setShowRedirectPopup] = useState(false);
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const openAddFamilyProtectionDialog = (): any => {
        setFamilyProtectionDialogIsVisible(true);
    };

    const closeFamilyProtectionDialog = (): any => {
        setFamilyProtectionDialogIsVisible(false);
    };
    const openRedirectPopup = ()=>{
        setShowRedirectPopup(true)
    }
    const closeRedirectPopup = ()=>{
        setShowRedirectPopup(false)
    }

    useEffect(() => {
        const initialUrl = window.location.href;
        sessionStorage.setItem("initialUrl", encodeURIComponent(initialUrl));
        getAccountInformation();
        if (isAvastId) {
            document.title = "Avast | Manage Profile | My Profile";
        }
        if (isAVGId || isAVGTestId) {
            document.title = "AVG | Manage Profile | My Profile";
        }
      

    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const ssoOption = useSelector(
        (state: ApplicationState) =>
            (state.configurationState &&
                state.configurationState.configuration &&
                state.configurationState.configuration.partnerConfig &&
                state.configurationState.configuration.partnerConfig.ssoOptions) ||
            null
    );

    const showPasswordChange = () => {
        if (ssoOption) {
            return ssoOption.allowChangePassword;
        }
        return accountInfo && !accountInfo.isSSOUser;
    };

    return (
        <React.Fragment>
            <TUAuthentication />

            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="my-account-page" tabIndex={-1}>
                        {(isAvastId || isAVGId || isAVGTestId ) ? "Manage Profile" : tLang("manageAccount.title")}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ManageAccountTab selectedTab="1" isAvastId={isAvastId || isAVGId || isAVGTestId} />

            <div className="row" id="content">
                {useCheckAnyServiceActive() ? (
                    <div className="col-xs">
                        {!isLoading || !isLoadingFamilyOffer ? (
                            <>
                                {/* My Account */}
                                {isBusinessUser ? <BusinessUserAccount /> : <Account setDialogue={openRedirectPopup}/>}

                                {/* Password */}
                                {showPasswordChange() && (
                                    <ManageAccountPassword
                                        showDashboardSecurityQuestionDialog={showDashboardSecurityQuestionDialog}
                                        setShowDashboardSecurityQuestionDialog={setShowDashboardSecurityQuestionDialog}
                                    />
                                )}

                                {/* Security */}
                                {accountInfo && !accountInfo.isSSOUser && !showDashboardSecurityQuestionDialog && <ManageAccountSecurity />}

                                {/* Preferences */}
                                <Preferences />

                                {/* Two-Factor Authentication */}
                                {accountInfo && accountInfo.isSSOUser === false && <TwoFactorAuth />}

                                {/* Billing Information */}
                                <ErrorBoundary componentName="Billing Information" type="hideError" replaceDefaultContent={false} errorMsg="">
                                    {!isBillingSectionHide && (<BillingInformation />)}
                                </ErrorBoundary>

                                {/* Family Protection */}
                                {(isFamilyProtectionServiceActive ||
                                    isSFRServiceActive ||
                                    (familyOffer && (familyOffer.familyAdultOffer?.hasAdultOffer || familyOffer.familyChildOffer?.hasChildOffer))) && (
                                    <FamilyProtection openAddFamilyProtectionDialog={openAddFamilyProtectionDialog} />
                                )}
                                <IDFFamilyProtection history={props.history} openAddFamilyProtectionDialog={openAddFamilyProtectionDialog} />

                                {/* Download the App */}
                                <DownloadApp showIcon={true} title={tLang("manageAccount.myAccount.mobileApp.title")} isManageAccount={true} />
                            </>
                        ) : (
                            <div className="box offset-padding">
                                <div className="box-header">
                                    <div className="loading"></div>
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="row margin-bottom-s" id="content">
                        <div className="box col-xs-12">
                            <div className="box-content">
                                <div className="data-grid" role="grid" style={{ backgroundColor: "#F2F6F9", padding: "10px" }}>
                                    <div role="row" className="box-header col-xs-12 col-sm-12 ">
                                        <div role="gridcell" className="content-sub-title text-align-center">
                                            <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                                <em className="las la-exclamation-circle "></em>
                                            </div>
                                        </div>
                                    </div>
                                        <div role="row" className="box-content text-align-center">
                                            <div role="gridcell">
                                                <p>{tLang("dashboard.noServiceActive.message")}</p>
                                                <p>
                                                    <Link to="/manage-account/protection-plan" className="default_link">
                                                        {tLang("dashboard.noServiceActive.protectionPlanLink")}
                                                    </Link>
                                                </p>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {isFamilyProtectionDialogVisible && (
                <DialogComponent dialogId="dialog-add-family-member-account-dialog" title="Add Family Member" closeDialog={closeFamilyProtectionDialog}>
                    <FamilyProtectionDialog closeDialog={closeFamilyProtectionDialog} />
                </DialogComponent>
            )}
            {showRedirectPopup && (
                <DialogComponent dialogId="dialog-redirection-dialog" title="Redirect To Vault" closeDialog={closeRedirectPopup}>
                    <RedirectToMonitoring closeDialog={closeRedirectPopup} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default MyAccount;
